// extracted by mini-css-extract-plugin
export var column1 = "OsGEGrZ1oebmWkZQdpPx";
export var column2 = "Dl1hwGIQOXP8F_WsBn8i";
export var content = "oQ6R6M0rCJ68L5s6cvo6";
export var header = "Hy2VVqUfuojxGG3fOw8u";
export var investmentsOverview = "emMF1cNIncAmdzqInSm7";
export var investmentsOverviewHeading = "qOh9MJEjqCbXrSi8azzt";
export var widgetsContainer = "akiC3N4KeT8es90VlGlm";